<div class="card h-100">
  <div class="card-header d-flex justify-content-between align-items-center border-0 bg-transparent p-3">
    <div>
      <h5 class="card-title mb-0 d-flex align-items-center gap-2">
        Customer Dispositions
        <kendo-svg-icon
          [icon]="infoCircleIcon"
          size="small"
          class="info-icon"
          kendoTooltip
          title="Breakdown of customer selected disposition types for the selected period, when available. Directly supports reduction of false positives and unknown outcomes."
        ></kendo-svg-icon>
      </h5>
    </div>
    <kendo-dropdownbutton
      kendoButton
      [svgIcon]="moreVerticalIcon"
      fillMode="flat"
      size="small"
      [data]="[{ text: 'View Data' }]"
      (itemClick)="onContextMenuSelect({ text: 'View Ticket Data' })"
    ></kendo-dropdownbutton>
  </div>
  <div class="card-body p-0">
    @if (isEmpty()) {
      <div class="empty-state-overlay">
        <div class="empty-state-content">
          <kendo-svgicon
            [icon]="unlockIcon"
            class="empty-state-icon"
          ></kendo-svgicon>
          <h6 class="empty-state-title">Unlock this widget</h6>
          <p class="empty-state-message">
            Start using the Customer Defined Status field in your ticketing portal to see detailed disposition data
            here.
          </p>
        </div>
      </div>
    } @else {
      <div class="list-group list-group-flush">
        @for (disposition of formattedDispositions(); track disposition.disposition) {
          <div class="list-group-item d-flex justify-content-between align-items-center py-2 px-3">
            <span class="text-truncate me-2">{{ disposition.disposition }}</span>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted small">{{ disposition.formattedPercentage }}%</span>
              <span
                class="badge"
                [class]="'bg-' + getCountSeverity(disposition.percentage)"
              >
                {{ disposition.formattedCount }}
              </span>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Reusable Ticket Data Dialog -->
@if (ticketDialogConfig()) {
  <app-ticket-data-dialog
    [config]="ticketDialogConfig()!"
    [visible]="showTicketDialog()"
    (close)="onTicketDialogClose()"
    (exportCsv)="triggerExport()"
  />
}
